import { styled } from '@mgmresorts/wcl-styled';
import { Box } from './Box.es.js';

var FlexRow = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap'
});

export { FlexRow };
